import React from "react";
import PropTypes from "prop-types";

import { List } from "../List";

function LegalListItem({ children, ...otherProps }) {
  return (
    <List.Item {...otherProps}>
      <List.Text>{children}</List.Text>
    </List.Item>
  );
}

LegalListItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

LegalListItem.displayName = "ModalLegal.ListItem";

export default LegalListItem;
